<template>
  <div id="lisProject-edit">
      <IForm :label-width="75" ref="formInline" :model="edit" :elem="editElem" :rules="editRule" :submit="false"  @on-submit="toSubmit">
        <div slot="extend">
          <Row>
            <Col span="12">
              <FormItem label="上级名称">
                <Input :value="lisProjectName" type="text" placeholder="请输入上级名称" :disabled="disabled"/>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="名称" prop="name">
                <Input v-model="edit.name" type="text" placeholder="请输入名称" maxlength="50"/>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="编码" prop="code">
                <Input v-model="edit.code" type="text" placeholder="请输入编码" maxlength="50"/>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="类型" prop="type">
                <Select v-model="edit.type" :disabled="disabled">
                  <Option v-for="item in enums.lisTypes" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="抽血试管">
                <Input :value="bloodTubeName" type="text" placeholder="请输入抽血试管" :disabled="disabled"/>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="送检机构">
                <Input :value="inspectOrganizeName" type="text" placeholder="请输入送检机构" :disabled="disabled"/>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="状态" prop="status">
                <Select v-model="edit.status">
                  <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="备注" prop="remark">
                <Input v-model="edit.remark" type="text" placeholder="请输入备注"/>
              </FormItem>
            </Col>
          </Row>

        </div>

      </IForm>
  </div>
</template>
<script>
import {_get, _save } from "@/services/screeningConfig/lisOption.js";
import {enums} from "@/services/enums";

export default {
  name: "LisProjectChild",
  props:{
    lisProjectId:{
      type:String,
      default:()=>{
        return ""
      }
    },
    lisProjectName:{
      type:String,
      default:()=>{
        return ""
      }
    },
    lisProjectCode:{
      type:String,
      default:()=>{
        return ""
      }
    },
    bloodTubeName:{
      type:String,
      default:()=>{
        return ""
      }
    },
    inspectOrganizeName:{
      type:String,
      default:()=>{
        return ""
      }
    },
  },
  data() {
    return {
      edit: {
        lisProjectId:"",
        name: "",
        code: "",
        type: 2,
        remark: "",
        status: 1
      },
      disabled: true,
      init: "",
      enums: enums,
      editElem: [],
      editRule: {
        name: [
          {required: true, message: '名称不能为空', trigger: 'blur'},
          {maxlength:50,message:"名称长度不能超过50",trigger: 'blur'}
        ],
        code: [
          {required: true, message: '编码不能为空', trigger: 'blur'}
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
            type:'number'
          }
        ],
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    handleModal(create, row) {
      this.$refs["formInline"].handleReset();
      if (create) {
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
    },
    handleEdit(row) {
      _get({id: row.id}).then(res =>{
        this.edit = Object.assign({}, res.data);
        this.edit.type = 2;
        this.edit.lisProjectId = this.lisProjectId;
        this.$forceUpdate();
      })
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      this.edit.lisProjectId = this.lisProjectId;
      _save(this.edit).then(res => {
        if (res.errcode === 1) {
          this.$message.success("保存成功");
          this.$emit("on-submit", false);
        } else {
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/.ivu-input[disabled], fieldset[disabled] .ivu-input {
  background-color: #f3f3f38c;
  opacity: 1;
  cursor: not-allowed;
  color: #303133;
}

/deep/.ivu-checkbox-disabled+span {
  background-color: #f3f3f38c;
  opacity: 1;
  cursor: not-allowed;
  color: #303133;
}

/deep/.el-input.is-disabled .el-input__inner {
  background-color: #f3f3f38c;
  opacity: 1;
  cursor: not-allowed;
  color: #303133;
}

/deep/.ivu-select-disabled .ivu-select-selection {
  background-color: #f3f3f38c;
  opacity: 1;
  cursor: not-allowed;
  color: #303133;
}
</style>
